import { useEffect, ReactNode, memo } from "react";
import { ComposeProviders, modules } from "byzantine";
import { LoadingSkeleton } from "@narmi/design_system";

interface AlertsWrapperProps {
  children: ReactNode;
}

const AlertsWrapperInner = ({ children }: AlertsWrapperProps) => {
  const { load, loading } = modules.alerts.bootstrap.useBootstrap();

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return <LoadingSkeleton content="paragraph" lines={6} isLoading />;
  }

  return children;
};

interface AlertsFormWrapperProps {
  children: ReactNode;
}

const FORM_PROVIDERS = [
  modules.alerts.accountAlertForm.Provider,
  modules.alerts.transactionAlertForm.Provider,
  modules.alerts.loanAlertForm.Provider,
  modules.alerts.emptyAlertForm.Provider,
];

const AlertsFormWrapper = ({ children }: AlertsFormWrapperProps) => (
  <ComposeProviders components={FORM_PROVIDERS}>
    {children || null}
  </ComposeProviders>
);
const AlertsWrapper = modules.alerts.bootstrap.WrapComponent(
  memo(AlertsWrapperInner)
);
export { AlertsWrapper };

export default AlertsFormWrapper;
